import React from 'react';
import {
  normalizeChecklistItems,
  subTaskCompletion,
} from './actionChecklistModel';

type SubTaskCompletionRingProps = {
  checklist: unknown;
  size?: number;
};

/**
 * Proportion of sub-tasks that are Closed. Hidden when the task has none.
 */
export const SubTaskCompletionRing: React.FC<SubTaskCompletionRingProps> = ({
  checklist,
  size = 22,
}) => {
  const { complete, total, percent } = subTaskCompletion(
    normalizeChecklistItems(checklist)
  );
  if (total === 0) return null;

  const stroke = 3;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percent / 100) * circumference;
  const label = `Sub-Task Completion, ${complete} of ${total} complete`;

  return (
    <span
      className="tw:inline-flex tw:shrink-0 tw:items-center tw:gap-1.5 tw:text-muted-foreground"
      aria-label={label}
      title={label}
    >
      <svg
        width={size}
        height={size}
        className="tw:-rotate-90"
        aria-hidden="true"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          className="tw:opacity-25"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={
            percent >= 100 ? 'tw:text-emerald-500' : 'tw:text-foreground'
          }
        />
      </svg>
      <span className="tw:flex tw:flex-col tw:leading-tight">
        <span className="tw:text-[10px] tw:font-semibold tw:tracking-wide tw:uppercase">
          Sub-Task Completion
        </span>
        <span className="tw:text-xs tw:tabular-nums tw:text-foreground">
          {complete}/{total}
        </span>
      </span>
    </span>
  );
};

export default SubTaskCompletionRing;
